"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyValue = isEmptyValue;
function isEmptyValue(value) {
    if (value !== null && typeof value === 'object' && 'value' in value) {
        return isEmptyValue(value.value);
    }
    return (value === undefined ||
        value === null ||
        (typeof value === 'object' && Object.keys(value).length === 0) ||
        (typeof value === 'string' && value.trim() === ''));
}
//# sourceMappingURL=ValueValidation.js.map